module.exports = __webpack_public_path__ + "img/verf-rood.70822a3e.jpeg";